module.exports = __webpack_public_path__ + "img/company_information.37824f0d.png";